import {useEffect} from "react";

/**
 * This is less of a pause and resume, and more of a
 * reset functionality. Initial attempt with pause and
 * resume was finnicky and didn't bring much to the UX.
 * It was also difficult to test.
 *
 * @export
 * @param {*} {callback, delay, pause}
 */
export default function usePausableDelay({callback, delay, pause}) {
    useEffect(() => {
        if (pause) return;

        const id = setTimeout(() => {
            callback();
        }, delay);

        return () => {
            clearTimeout(id);
        };
    }, [callback, delay, pause]);
}
